/** @jsx jsx */
import { jsx, css } from "@emotion/core";
// import React from "react";

const GymTitle = () => (
  <h2 css={styles}>
    <span>PROGRAMS</span> OFFERED BY US
  </h2>
);

const styles = css`
  color: #232d39;
  font-size: 26px;
  font-weight: 900;
  line-height: 1;
  span {
    color: #dd3333;
  }
`;

export default GymTitle;
